import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent } from "vue";
const _hoisted_1 = { class: "content-wrapper" };
const _hoisted_2 = { class: "option-ctrl-area" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_icon = _resolveComponent("v-icon");
    const _component_v_btn = _resolveComponent("v-btn");
    const _component_CardSection = _resolveComponent("CardSection");
    const _directive_btn_style = _resolveDirective("btn-style");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailPages, ({ title, pageType }, key) => {
            return (_openBlock(), _createBlock(_component_CardSection, {
                key: title,
                title: title,
                m0: ""
            }, {
                titleContent: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                        _createCommentVNode(" 배달대행료 버튼 "),
                        (key === 1)
                            ? _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                key: 0,
                                "data-cy": "delivery-charge-open-btn",
                                class: "mr-2",
                                onClick: _ctx.handleClickDeliveryChargeBtn
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                        default: _withCtx(() => _cache[1] || (_cache[1] = [
                                            _createTextVNode(" mdi-moped-outline ")
                                        ])),
                                        _: 1 /* STABLE */,
                                        __: [1]
                                    }),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('views.delivery_charge_dialog.header.title')), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick"])), [
                                [
                                    _directive_btn_style,
                                    void 0,
                                    "config",
                                    {
                                        info: true,
                                        outlined: true,
                                        "size-m": true
                                    }
                                ]
                            ])
                            : _createCommentVNode("v-if", true),
                        _createCommentVNode(" 배달 가능 동 설정 다이얼로그 버튼 "),
                        (pageType === _ctx.receptionOperationType)
                            ? _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                key: 1,
                                class: "mr-2",
                                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.handleClickDeliveryPossibleAreaBtn()))
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                        default: _withCtx(() => _cache[2] || (_cache[2] = [
                                            _createTextVNode(" mdi-cog-outline ")
                                        ])),
                                        _: 1 /* STABLE */,
                                        __: [2]
                                    }),
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('views.store_delivery_possible_area.title')), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            })), [
                                [
                                    _directive_btn_style,
                                    void 0,
                                    "config",
                                    {
                                        info: true,
                                        outlined: true,
                                        "size-m": true
                                    }
                                ]
                            ])
                            : _createCommentVNode("v-if", true),
                        _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                            onClick: ($event) => (_ctx.editBtnHandler(pageType))
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_icon, { small: "" }, {
                                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                                        _createTextVNode(" mdi-pencil-outline ")
                                    ])),
                                    _: 1 /* STABLE */,
                                    __: [3]
                                }),
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.modify')), 1 /* TEXT */)
                            ]),
                            _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])), [
                            [
                                _directive_btn_style,
                                void 0,
                                "config",
                                {
                                    info: true,
                                    outlined: true,
                                    "size-m": true
                                }
                            ]
                        ])
                    ])
                ]),
                default: _withCtx(() => [
                    (_ctx.storeDetail)
                        ? (_openBlock(), _createBlock(_resolveDynamicComponent(pageType), {
                            key: 0,
                            detail: _ctx.storeDetail,
                            class: "brg-input-section-dense-wrapper"
                        }, null, 8 /* PROPS */, ["detail"]))
                        : _createCommentVNode("v-if", true)
                ]),
                _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["title"]));
        }), 128 /* KEYED_FRAGMENT */))
    ]));
}
